<template>
  <div class="transactionHistory">
    <adx-transaction 
      ref="media"
      :display="display"
    />
  </div>
</template>

<script>
import Transaction from '@/views/Transaction'

export default {
  name: 'adx-dashboard-transaction-history',
  components: {
    'adx-transaction': Transaction
  },
  props: {
    
  },
  data() {
    return {
      display: 'grid'
    }
  },
  computed: {

  },
  watch: {
    
  },
  beforeCreate() {

  },
  created() {
    
  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>

<style lang="scss">
.transactionHistory {
  .transaction {
    .sidebar {
      display: none;
    }
    .container-router {
      width: 100%;
    }
  }
}
</style>
